import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { environment } from '../../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ShowVisitasPedidosGuardService {

    constructor(public router: Router) {}

    canActivate(): boolean | UrlTree {
        if (environment.appName !== 'agroleza') {
            return this.router.parseUrl('/login');
        }
        return true;
    }
}
